import { jsx } from "react/jsx-runtime";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import { validateTidalLicense } from "../../base/index.js";
function Bookmark(props) {
  return /* @__PURE__ */ jsx(
    BookmarkIcon,
    {
      "data-testid": "Bookmark",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Bookmark",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
Bookmark.tidalIconMeta = {
  categories: "miscellaneous",
  name: "Bookmark"
};
validateTidalLicense();
export {
  Bookmark
};
//# sourceMappingURL=Bookmark.js.map
